/**
 * Promo Banners Component
 * Two promotional cards for TAB-001
 * Token-only colors
 */

import { useSafeNavigate } from '@/hooks/useSafeNavigate';
import { toast } from 'sonner';

// Import illustrations
import promoIllustration from '@/assets/promo-illustration.png';
import promoIllustrationDog from '@/assets/promo-illustration-dog.png';

const showComingSoon = () => {
  toast('Скоро появится', {
    description: 'Мы уже работаем над этим функционалом!',
  });
};

const PromoBanners = () => {
  const navigate = useSafeNavigate();

  const handleQuizClick = () => {
    navigate('/quiz');
  };

  return (
    <div className="grid grid-cols-2 gap-3">
      {/* Card 1 - друзья проекта */}
      <button
        onClick={showComingSoon}
        className="relative overflow-hidden text-left"
        style={{
          borderRadius: '20px',
          height: '120px',
        }}
      >
        <div className="absolute top-2 left-2.5 right-1 z-10">
          <span
            className="text-text-primary font-black text-[15px] lowercase leading-[1.1]"
            style={{ fontFamily: '"CoFo Gothic", system-ui, sans-serif' }}
          >
            друзья
            <br />
            проекта
          </span>
        </div>
        <img
          src={promoIllustration}
          alt="Друзья проекта"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </button>

      {/* Card 2 - тест: ваш идеальный питомец → Quiz */}
      <button
        onClick={handleQuizClick}
        className="relative overflow-hidden text-left"
        style={{
          borderRadius: '20px',
          height: '120px',
        }}
      >
        <div className="absolute top-2 left-2.5 right-1 z-10">
          <span
            className="text-text-primary font-black text-[15px] lowercase leading-[1.1]"
            style={{ fontFamily: '"CoFo Gothic", system-ui, sans-serif' }}
          >
            тест: ваш
            <br />
            идеальный
            <br />
            питомец
          </span>
        </div>
        <img
          src={promoIllustrationDog}
          alt="Тест: ваш идеальный питомец"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </button>
    </div>
  );
};

export default PromoBanners;
